import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material";
import { MatDialog } from "@angular/material/dialog";
import { DOCUMENT } from "@angular/common";
import { BAAComponent } from "../baa/baa.component";
import { TermsandConditionsComponent } from "../termsand-conditions/termsand-conditions.component";
import { HealthSystemService } from "../core/services/v2/health-system.service";
import { PDFDialogComponent } from "./pdf-dialog/pdf-dialog.component";

const DialogOption = {
  width: '85%',
}

@Component({
  selector: "signup-organization",
  templateUrl: "./signup-organization.component.html",
  styleUrls: ["./signup-organization.component.scss"],
})
export class SignupOrganizationComponent implements OnInit {
  activeTab: number;
  isLinear: boolean = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  isDisplayThankYou: boolean = false;
  healthOrgTypes: any[] = [];
  healthOrgSubTypes: any[] = [];
  isDataLoaded: boolean = false;
  isFormSubmitting: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog, private healthSystemService: HealthSystemService
  ) {
    this.initForm();
  }

  async ngOnInit(): Promise<void> {
    await this.getHealthOrganizationTypes();
    await this.getHealthOrganizationSubscriptionTypes();

    this.activeTab = 1;
  }

  GoToFinish() {
    this.isDisplayThankYou = true;
  }

  Back(tab) {
    if (tab === 3) {
      this.isDisplayThankYou = false;
    }
    this.activeTab = tab;
  }

  onSubscriptionTypeSelect(id: number) {
    this.fourthFormGroup.controls['healthOrganizationSubscriptionType'].setValue(id);
  }

  finish() {
    return (this.document.location.href = `/Session/SignIn?redirectUrl=/app/userhome`);
  }

  onSubmit(tab): void {
    if (tab === 5) { //Submit the form
      this.onFormSubmit();
    } else {
      this.activeTab = tab;
    }
  }

  openbaaDialog() {
    const dialogRef = this.dialog.open(PDFDialogComponent, {
      ...DialogOption,
      id: 'baa_dialog',
      data: {
        title: 'Appy Health Business Associate Agreement',
        filename: 'AH–-Business-Associate-–-Healthcare-Provider-Agreement-–-November-2022-–-A7.pdf',
        isBack: true,
      }
    });
    dialogRef.afterClosed().subscribe(
      (rest) => {
        this.thirdFormGroup.controls["IsAcceptedBaa"].setValue(rest);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  openSaaSAgreementDialog() {
    const dialogRef = this.dialog.open(PDFDialogComponent, {
      ...DialogOption,
      id: 'sass_dialog',
      data: {
        title: 'Appy Health Saas Agreement',
        filename: 'AH-HPA-SaaS-Agreement-November-2022-v-1.032.pdf',
        isBack: true,
      }
    });
    dialogRef.afterClosed().subscribe(
      (rest) => {
        this.thirdFormGroup.controls["IsAcceptedTermsConditions"].setValue(rest);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  openPdfDialog(type: number) {
    let data = {
      title: 'Appy Health Pricing',
      filename: 'AH-Practice-Clinic-Pricing-11-4-2022.pdf',
    }
    if (type === 2) {
      data = {
        title: 'Appy Health Money Back Guarantee',
        filename: 'AH-Money-Back-Guarantee-11.14.2022-D5.pdf',
      }
    } else if (type === 3) {
      data = {
        title: 'Appy Health Cancellation Policy',
        filename: 'AH-Cancellation-Policy-11.14.2022-D9.pdf',
      }
    }

    this.dialog.open(PDFDialogComponent, { ...DialogOption, id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }

  getOrgTypeDisplayValue(orgType) {
    let orgTypeName = orgType.name;
    let orgTypeDesc = orgType.description;

    if((orgTypeDesc != null && orgTypeDesc != '') && orgTypeName.toLowerCase() != orgTypeDesc.toLowerCase()){
      return `${orgTypeName} (${orgTypeDesc})`;
    } else {
      return orgTypeName;
    }
  }

  private async getHealthOrganizationTypes(){
    await this.healthSystemService.getHealthOrganizationTypes().subscribe((res)=>{
      if(res.resultStatus.isSuccess){
        this.healthOrgTypes = res.result;
        this.firstFormGroup.get('healthOrganizationType').setValue(this.healthOrgTypes[0].id);
      }
    });
  }

  private async getHealthOrganizationSubscriptionTypes() {
    await this.healthSystemService.getHealthOrganizationSubscriptionTypes().subscribe((res) => {
      if (res.resultStatus.isSuccess) {
        this.healthOrgSubTypes = res.result;
        this.isDataLoaded = true;
        this.fourthFormGroup.get('healthOrganizationSubscriptionType').setValue(this.healthOrgSubTypes[0].id);
      }
    });
  }

  private initForm(){
    this.firstFormGroup = this._formBuilder.group({
      healthOrganizationType: [, Validators.required],
      name: ["", Validators.required],
      phoneNumber: ["", Validators.required],
      webAddress: ["", Validators.required],
    });

    this.secondFormGroup = this._formBuilder.group({
      address: ["", Validators.required],
      city: ["", Validators.required],
      state: ["", Validators.required],
      zip: ["", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("^[0-9]*$")]],
    });

    this.thirdFormGroup = this._formBuilder.group({
      contactName: ["", Validators.required],
      email: ["", Validators.required],
      IsCertify: ["", Validators.required],
      IsAcceptedBaa: ["", Validators.required],
      IsAcceptedTermsConditions: ["", Validators.required],
    });

    this.fourthFormGroup = this._formBuilder.group({
      healthOrganizationSubscriptionType: [, Validators.required],
    });
  }

  private async onFormSubmit(): Promise<void> {
    const { healthOrganizationType, name, phoneNumber, webAddress } = this.firstFormGroup.value;
    const {address, city, state, zip } = this.secondFormGroup.value;
    const { contactName, email, IsCertify, IsAcceptedBaa, IsAcceptedTermsConditions } = this.thirdFormGroup.value;
    const { healthOrganizationSubscriptionType } = this.fourthFormGroup.value;

    const formData = new FormData();
    formData.append("Name", name);
    formData.append("IsCertify", IsCertify);
    formData.append("IsAcceptedTermsConditions", IsAcceptedTermsConditions);
    formData.append("IsAcceptedBaa", IsAcceptedBaa);
    formData.append("WebAddress", webAddress);
    formData.append("PhoneNumber", phoneNumber);
    formData.append("Line", address);
    formData.append("Line2", "");
    formData.append("City", city);
    formData.append("State", state);
    formData.append("ZipCode", zip);
    formData.append("AdminName", contactName);
    formData.append("AdminEmail", email);
    formData.append("HealthOrganizationType", healthOrganizationType);
    formData.append("SubscriptionTypeId", healthOrganizationSubscriptionType);

    this.isFormSubmitting = true;

    await this.healthSystemService.organizationSignup(formData).subscribe((res) => {
      if (res && res.isSuccess) {
        this.document.location.href = "https://appyhealth.com/"
      }

      this.isFormSubmitting = false;
    });
  }
}
